import React from 'react'
import { useState } from 'react'
import './header.css'
import { useInView } from 'react-intersection-observer'
import { useEffect } from 'react';


function Header() {
    // change background header

    const { ref , inView } = useInView();



    useEffect(()=>{
        if(inView) {
            if(window.innerWidth > 767){

                document.querySelectorAll(".nav__item").forEach((item)=>{
                    
                    item.style.transform = "translateY(0px)";
                    
                })
            }
        }
    },[inView])



    window.addEventListener("scroll",function (){
        const header = document.querySelector(".header")

        if( this.scrollY >= 80) header.classList.add("scroll-header")
        else header.classList.remove("scroll-header")
    })


    // toggle menu 
    const [toggle , setToggle] = useState(false)
    const [activeNav , setActiveNav] = useState("#home")
    return (
        <header className="header">
            <nav  className="nav container">
                <a href="index.html" className="nav__logo">Manas</a>


                <div className={ toggle ? "nav__menu show-menu" : "nav__menu"} ref={ref}>
                    <ul className="nav__list grid">
                        <li className="nav__item" style={{"transitionDelay":" 0"}} >
                            <a href="#home" onClick={()=> setActiveNav("#home")} className={activeNav === "#home" ? "nav__link active-link" : "nav__link" }>
                                <i className="uil uil-estate nav__icon"></i> Home
                            </a>
                        </li>

                        <li                     
                        className="nav__item" style={{"transitionDelay":" 0.1s"}} >
                            <a href="#about" onClick={()=> setActiveNav("#about")} className={activeNav === "#about" ? "nav__link active-link" : "nav__link" }>
                                <i className="uil uil-user nav__icon"></i> About
                            </a>
                        </li>

                        <li                     
                        className="nav__item" style={{"transitionDelay":" 0.2s"}} >
                            <a href="#skills" onClick={()=> setActiveNav("#skills")} className={activeNav === "#skills" ? "nav__link active-link" : "nav__link" }>
                                <i className="uil uil-file-alt nav__icon"></i>Skills
                            </a>
                        </li>

                        <li                     
                        className="nav__item" style={{"transitionDelay":" 0.3s"}} >
                            <a href="#services" onClick={()=> setActiveNav("#services")} className={activeNav === "#services" ? "nav__link active-link" : "nav__link" }>
                                <i className="uil uil-briefcase-alt nav__icon"></i> Services 
                            </a>
                        </li>

                        <li                   
                        className="nav__item" style={{"transitionDelay":" 0.4s"}} >
                            <a href="#portfolio" onClick={()=> setActiveNav("#projects")} className={activeNav === "#projects" ? "nav__link active-link" : "nav__link" }>
                                <i className="uil uil-scenery nav__icon"></i> Projects
                            </a>
                        </li>

                        <li                     
                        className="nav__item" style={{"transitionDelay":" 0.5s"}} >
                            <a href="#contact" onClick={()=> setActiveNav("#contact")} className={activeNav === "#contact" ? "nav__link active-link" : "nav__link" }>
                                <i className="uil uil-message nav__icon"></i> Contact
                            </a> 
                        </li>
                    </ul>
                    <i  className='uil uil-times nav__close' onClick={()=> setToggle(!toggle)}></i>
                </div>
                <div className="nav__toggle" onClick={()=> setToggle(!toggle)}>
                    <i className="uil uil-apps"></i>
                </div>
                </nav>
        </header>
    )
}

export default Header